import { useEffect } from 'preact/hooks';
import { makeT } from '../i18n';
import { getState, refreshTransit, useAppState } from '../state';
import { Album, Zoom } from './Album';
import { AddressBook, Compose, StampPicker } from './Compose';
import { Login } from './Login';
import { Mailbox } from './Mailbox';
import { EditAddress, Profile } from './Profile';
import { Reader } from './Reader';
import { Sent } from './Sent';
import { Loading, Sidebar, Toast, Topbar } from './Shell';
import { ConfirmCancel, Track } from './Track';
import { Welcome } from './Welcome';

// Read once, then tidy the marker out of the address bar.
const authFailed = new URLSearchParams(window.location.search).get('auth') === 'failed';
if (authFailed) window.history.replaceState({}, '', window.location.pathname);

export function App() {
  const s = useAppState();
  const t = makeT(s.lang);

  useEffect(() => {
    document.documentElement.lang = s.lang;
  }, [s.lang]);

  // Re-poll outgoing mail so a card that lands drops off tracking without a reload.
  useEffect(() => {
    const id = window.setInterval(() => {
      if (document.visibilityState === 'visible' && getState().user) void refreshTransit();
    }, 60_000);
    return () => window.clearInterval(id);
  }, []);

  if (!s.ready) return <Loading t={t} />;
  if (!s.user) return <Login t={t} failed={authFailed} />;
  // Delivery times depend on where you write from, so ask before anything else.
  if (!s.user.countryChosen) return <Welcome s={s} t={t} />;

  return (
    <>
      <div class="app">
        <Topbar s={s} />
        <Sidebar s={s} t={t} />
        <main class="stage">
          {s.tab === 'mailbox' && <Mailbox s={s} t={t} />}
          {s.tab === 'track' && <Track s={s} t={t} />}
          {s.tab === 'compose' && <Compose s={s} t={t} />}
          {s.tab === 'album' && <Album s={s} t={t} />}
          {s.tab === 'profile' && <Profile s={s} t={t} />}
        </main>
      </div>
      {s.openCardId && <Reader s={s} t={t} />}
      {s.sentCard && <Sent s={s} t={t} />}
      {s.addressOpen && <AddressBook s={s} t={t} />}
      {s.pickerOpen && <StampPicker s={s} t={t} />}
      {s.zoomIndex !== null && <Zoom s={s} t={t} />}
      {s.confirmCancelId && <ConfirmCancel s={s} t={t} />}
      {s.editOpen && <EditAddress s={s} t={t} />}
      <Toast s={s} />
    </>
  );
}
